import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import type { PaginationState } from "@/hooks/usePagination";

interface Props {
  pagination: PaginationState;
}

export function PaginationControls({ pagination }: Props) {
  const { page, totalPages, totalCount, canPrev, canNext, prevPage, nextPage, from, pageSize } = pagination;
  if (totalCount <= pageSize) return null;

  const showingFrom = from + 1;
  const showingTo = Math.min(from + pageSize, totalCount);

  return (
    <div className="flex items-center justify-between pt-3">
      <span className="text-xs text-muted-foreground">
        Showing {showingFrom}–{showingTo} of {totalCount}
      </span>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" disabled={!canPrev} onClick={prevPage}>
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="text-xs text-muted-foreground px-2">
          Page {page} of {totalPages}
        </span>
        <Button variant="outline" size="sm" disabled={!canNext} onClick={nextPage}>
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
